import Layout from './layouts/Layout';
import DigitalTwin from './pages/DigitalTwin';
import Home from './pages/Home';
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/digital-twin" element={<DigitalTwin />} />
      </Routes>
    </Layout>
  );
}

export default App;
